import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Sidebar } from "./components";

const ProtectedRouteWithSidebar = () => {
  const isAuthenticated = Boolean(localStorage.getItem("accessToken"));
  const [isSidebarClose, setIsSidebarClose] = useState(false);

  useEffect(() => {
    console.log(isSidebarClose);
  }, [isSidebarClose]);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      <Sidebar sidebarOpen={setIsSidebarClose} />
      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px", maxWidth: !isSidebarClose ? "calc(100% - 300px)" : "calc(100% - 120px)" }}>
        <Outlet />
      </div>
    </div>
  );
};

export default ProtectedRouteWithSidebar;
